import request from '@/utils/request.js'
//文章列表
export function articleList(query) {
  return request({
    url: '/system/notice/list',
    method: 'get',
    params: query
  })
}
//文章详情
export function articleDetails(noticeId) {
  return request({
    url: '/system/notice/' + noticeId,
    method: 'get'
  })
}
// 轮播
export function imgsList() {
  return request({
    url: '/system/homePage/list',
    method: 'get'
  })
}

// 平台查询列表
export function listPlatform(query) {
  return request({
    url: 'system/platform/list',
    method: 'get',
    params: query
  })
}

//验证码
export function getCodeImg() {
  return request({
    url: 'captchaImage',
    headers: {
      isToken: false
    },
    method: 'get'
  })
}

// 登录方法
export function login(username, password, code, uuid) {
  const data = {
    username,
    password,
    code,
    uuid
  }
  return request({
    url: '/login',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

//重置密码
export function resetPwd(data) {
  return request({
    url: '/system/user/resetPwd',
    method: 'put',
    data: data
  })
}
//获取用户信息
export function getInfo() {
  return request({
    url: '/getInfo',
    method: 'get'
  })
}
